export default __webpack_public_path__ + "static/media/udemy-1.eb019ae2.png";